/** Client-side password rules — signup and SA user create/edit (when password is set). */

export const PASSWORD_POLICY_HINT =
  'At least 8 characters with a number and special character.';

export const PASSWORD_POLICY_ERROR_MESSAGE =
  'Password must be at least 8 characters and include a number and a special character.';

const PASSWORD_SPECIAL_CHAR_REGEX = /[!@#$%^&*(),.?":{}|<>]/;

export function isPasswordPolicyCompliant(password: string): boolean {
  return (
    password.length >= 8 &&
    /\d/.test(password) &&
    PASSWORD_SPECIAL_CHAR_REGEX.test(password)
  );
}
